import { useTranslator } from '@Localization';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { CollapsibleImportSummary } from '../../../components/CollapsibleSummary';
import { IImportToolRejection, ImportToolRejectionReason } from '../projects.model';

interface IProps {
  isLastSummaryItem?: boolean;
  isPanelOpen: boolean;
  handlePanelToggle: () => void;
  rejectedTools: IImportToolRejection[];
  importedToolsCount: number;
  skippedToolsCount: number;
}

export const ImportAnnotationToolsSummary = observer((props: IProps): ReactElement => {
  const { t } = useTranslator();

  const mapAnnotationToolRejectionReason = (reason: ImportToolRejectionReason): string => {
    switch (reason) {
      case ImportToolRejectionReason.INVALID_MARKING_TOOL_TYPE:
        return t('invalid_marking_tool_type');
      case ImportToolRejectionReason.INVALID_COLOR_FORMAT:
        return t('invalid_color_format');
      case ImportToolRejectionReason.INVALID_MARKING_TOOL_NAME:
        return t('invalid_marking_tool_name');
      case ImportToolRejectionReason.DUPLICATED_MARKING_TOOL_NAME:
        return t('duplicated_marking_tool_name');
      default:
        return t('unknown');
    }
  };

  const getRejectionReasons = (): string[] => {
    return props.rejectedTools.map((x) => {
      return `${x.toolName} - ${mapAnnotationToolRejectionReason(x.reason)}`;
    });
  };

  return (
    <>
      <CollapsibleImportSummary
        importedItemsCount={props.importedToolsCount}
        skippedItemsCount={props.skippedToolsCount}
        rejectionReasons={getRejectionReasons()}
        isPanelOpen={props.isPanelOpen}
        togglePanel={props.handlePanelToggle}
        isLastSummaryItem={props.isLastSummaryItem}
        importedMessage={t('annotation_tools_imported', { count: props.importedToolsCount })}
        skippedMessage={t('tools_skipped', { count: props.skippedToolsCount })}
      />
    </>
  );
});
